import { render, staticRenderFns } from "./chaternewPartnerType.vue?vue&type=template&id=2cf7634e&scoped=true"
import script from "./chaternewPartnerType.vue?vue&type=script&lang=js"
export * from "./chaternewPartnerType.vue?vue&type=script&lang=js"
import style0 from "./chaternewPartnerType.vue?vue&type=style&index=0&id=2cf7634e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf7634e",
  null
  
)

export default component.exports